//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'GFR_Salazar',
  data() {
    return {
      defaultJson: {
        "Weight": "体重",
        "Height": "身高",
        "Age": "年龄",
        "Clearance": "清除率",
        "Serum Creatinine": "血肌酐",
      },
      form: {
        age: '',
        height: '',
        weight: '',
        creat: '',
        gender: '',

      },
      contentDescription: '',
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "0", name: '男' },
        { value: "5", name: '女' },
      ],
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        console.log('gggggggg', form.creat);
        // console.log('xxxxxxxx', form.age, form.weight, form.height, form.height, form.creat);
        form.creat = form.creat * 1 / 88.417
        let result = form.gender == '5' ? [(146 - form.age) * (0.287 * form.weight + 9.74 * (form.height * form.height))] / (60 * form.creat) : [(137 - form.age) * (0.285 * form.weight + 12.1 * (form.height * form.height))] / (51 * form.creat)
        console.log(result, 'xxxxxxxx');
        self.hasScore = true
        return String(result.toFixed(0))
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/GFR_Salazar.vue